const GENERIC_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'yahoo.com',
  'yahoo.co.uk',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'fastmail.com',
  'hey.com',
  'gmx.com'
]);

const MULTIPART_PUBLIC_SUFFIXES = new Set([
  'co.uk',
  'org.uk',
  'gov.uk',
  'ac.uk',
  'com.au',
  'net.au',
  'org.au',
  'co.nz',
  'co.za'
]);

const stripCommonSubdomainPrefixes = (labels: string[]) => {
  const prefixes = new Set(['www', 'mail', 'app', 'team', 'hr']);

  if (labels.length > 2 && prefixes.has(labels[0])) {
    return labels.slice(1);
  }

  return labels;
};

const slugifyOrgId = (value: string) =>
  value
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');

const getSuggestedDomainStem = (email?: string) => {
  const domain = email
    ?.trim()
    .toLowerCase()
    .split('@')[1];

  if (!domain || GENERIC_EMAIL_DOMAINS.has(domain)) {
    return '';
  }

  const labels = stripCommonSubdomainPrefixes(
    domain.split('.').filter(Boolean)
  );

  if (labels.length < 2) {
    return '';
  }

  const publicSuffix = labels.slice(-2).join('.');
  const stemIndex = MULTIPART_PUBLIC_SUFFIXES.has(publicSuffix)
    ? labels.length - 3
    : labels.length - 2;

  return labels[stemIndex] || '';
};

const humanizeOrgName = (value: string) =>
  value
    .split(/[-_]+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.substring(1).toLowerCase())
    .join(' ');

export const suggestOrgIdFromName = (name?: string) =>
  slugifyOrgId(name?.trim() || '');

export const suggestOrgNameFromEmail = (email?: string) =>
  humanizeOrgName(getSuggestedDomainStem(email));

export const suggestOrgIdFromEmail = (email?: string) => {
  const stem = getSuggestedDomainStem(email);

  if (!stem) {
    return '';
  }

  return slugifyOrgId(stem);
};
